module.exports = __webpack_public_path__ + "images/retract.e7b9a6668fa5ab8a511ffd4f33df0e38.png";